<div [style.max-width]="width">
  <img
  [src]="getCastImage()"
  [style.width]="width"
  [style.height]="height"
  class="cast-image"
  (error)="onCastImageError($event)"
  loading="lazy"
  alt="Cast Image"
/>
  <p class="title" *ngIf="roleName" [style]="'fontSize.24' | translate">{{ roleName }}</p>
  <p class="content" [style]="'fontSize.24' | translate">{{ name }}</p>
</div>
